module.exports = __webpack_public_path__ + "static/media/yt-free-shipping.b3ddfca6.jpeg";